import React, { useEffect, useState, useRef } from 'react';
import { ZapIcon, ShieldCheckIcon, UserIcon } from 'lucide-react';
import { useTranslation } from '../../lib/i18n';
export function WhatIsDTech() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const {
    lang
  } = useTranslation();
  const en = lang === 'en';
  const ru = lang === 'ru';
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible(true);
    }, {
      threshold: 0.2
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  const items = en ? [{
    icon: <ZapIcon className="w-6 h-6 text-brand-yellow" data-id="element-277" />,
    label: 'Electric drive',
    text: 'A powerful motor for easy climbing with minimal operator effort.'
  }, {
    icon: <ShieldCheckIcon className="w-6 h-6 text-brand-yellow" data-id="element-278" />,
    label: 'Control & safety',
    text: 'Integrated automatic brake guarantees load stability at all times.'
  }, {
    icon: <UserIcon className="w-6 h-6 text-brand-yellow" data-id="element-279" />,
    label: 'Single operator',
    text: 'Designed so one person can safely handle heavy cargo without extra help.'
  }] : ru ? [{
    icon: <ZapIcon className="w-6 h-6 text-brand-yellow" data-id="element-280" />,
    label: 'Электрический привод',
    text: 'Мощный мотор для лёгкого подъёма с минимальными усилиями оператора.'
  }, {
    icon: <ShieldCheckIcon className="w-6 h-6 text-brand-yellow" data-id="element-281" />,
    label: 'Контроль и безопасность',
    text: 'Встроенный автоматический тормоз гарантирует стабильность груза в любой момент.'
  }, {
    icon: <UserIcon className="w-6 h-6 text-brand-yellow" data-id="element-282" />,
    label: 'Один оператор',
    text: 'Разработано так, чтобы один человек мог безопасно перемещать тяжёлые грузы без дополнительной помощи.'
  }] : [{
    icon: <ZapIcon className="w-6 h-6 text-brand-yellow" data-id="element-283" />,
    label: 'Električni pogon',
    text: 'Snažan motor za lako savladavanje uspona uz minimalan napor operatera.'
  }, {
    icon: <ShieldCheckIcon className="w-6 h-6 text-brand-yellow" data-id="element-284" />,
    label: 'Kontrola i bezbednost',
    text: 'Integrisana automatska kočnica garantuje stabilnost tereta u svakom trenutku.'
  }, {
    icon: <UserIcon className="w-6 h-6 text-brand-yellow" data-id="element-285" />,
    label: 'Jedan operater',
    text: 'Dizajnirano da jedna osoba bezbedno manipuliše teškim teretom bez dodatne pomoći.'
  }];
  return <section className="py-14 md:py-20 bg-dark-surface border-b border-dark-border" data-id="element-286">
      <div ref={ref} className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-287">
        <h2 className={`text-2xl md:text-3xl font-black text-white mb-10 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`} data-id="element-288">
          {en ? 'How does ' : ru ? 'Как работает ' : 'Kako funkcioniše '}
          <span className="text-brand-yellow" data-id="element-289">
            {en ? 'D-TECH?' : ru ? 'D-TECH?' : 'D-TECH?'}
          </span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-290">
          {items.map((item, i) => <div key={i} className="flex flex-col gap-3 p-5 bg-dark-bg border border-dark-border rounded-industrial" style={{
          transitionProperty: 'opacity, transform',
          transitionDuration: '700ms',
          transitionDelay: `${i * 150}ms`,
          opacity: visible ? 1 : 0,
          transform: visible ? 'translateY(0)' : 'translateY(24px)'
        }} data-id="element-291">
              <div className="flex items-center gap-3" data-id="element-292">
                {item.icon}
                <span className="text-brand-yellow font-bold text-base" data-id="element-293">
                  {item.label}
                </span>
              </div>
              <p className="text-gray-300 text-sm leading-relaxed" data-id="element-294">
                {item.text}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}